import { _ } from './../utils.js'
export default class SelectUrl {
    constructor(el) {
        this.el = el
        this.select = _('tab-select', 'element').nodeFrom(this.el)
        this.inputs = _('toggle-select').nodesFrom(this.el)

        this.inputs.map((input) => {
            input.addEventListener('click', this.changeSelectText)
            if (input.checked) {
                input.click()
            }
        })
    }

    changeSelectText = (e) => {
        this.select.innerHTML = e.target.dataset.value
    }
}
